module.exports = {
  search(words, recipes){
    words.forEach(word => {
      if(word.length > 1){
        word = word.toLowerCase()
        recipes = recipes.filter(recipe => {
          const categoryNames = recipe.Categories.map(category => category.Name)
          return  recipe.Title.toLowerCase().includes(word) || 
                  recipe.Ingredients.toLowerCase().includes(word) || 
                  categoryNames.find(name => name.toLowerCase().includes(word))
        })
      }
    })
    return recipes
  }
}